import { Text, View } from '@react-pdf/renderer'

import { styles } from '../styles/styles'

export const EditableFields = () => {
  return (
    <View break style={styles.editableFieldsPage}>
      <Text style={styles.actionBoxTitle}>Summary</Text>
      <View style={styles.editableBox}>
        <Text />
      </View>

      <Text style={{ ...styles.actionBoxTitle, ...styles.editableBoxGap }}>
        Action
      </Text>
      <View style={styles.editableBox}>
        <Text />
      </View>
    </View>
  )
}
